import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";
import Logo from "@/components/site/Logo";

export const NAV = [
  { to: "/", label: "Home", id: "home" },
  { to: "/software", label: "Software", id: "software" },
  { to: "/categories", label: "Categories", id: "categories" },
  { to: "/comparisons", label: "Comparisons", id: "comparisons" },
  { to: "/blog", label: "Blog", id: "blog" },
  { to: "/about", label: "About Us", id: "about" },
  { to: "/contact", label: "Contact", id: "contact" },
];

const linkCls = ({ isActive }) =>
  `relative px-3 py-2 rounded-lg text-[14px] font-medium transition-colors duration-200 ${isActive ? "text-[#17243A] after:absolute after:left-3 after:right-3 after:-bottom-[13px] after:h-[2px] after:rounded-full after:bg-[#0F766E]" : "text-[#526174] hover:text-[#17243A] hover:bg-[#F1F4F6]"}`;
const mobileCls = ({ isActive }) =>
  `px-3 py-3 rounded-lg text-[15px] font-medium transition-colors ${isActive ? "text-[#0F766E] bg-[#ECF6F4]" : "text-[#17243A] hover:bg-[#F1F4F6]"}`;

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 4);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
  useEffect(() => setOpen(false), [pathname]);
  return (
    <header data-testid="nav-header"
      className={`sticky top-0 z-50 backdrop-blur-xl border-b transition-[background-color,box-shadow,border-color] duration-300 ${scrolled || open ? "bg-white/95 border-[#DCE5E8] shadow-[0_6px_24px_-14px_rgba(23,36,58,0.25)]" : "bg-[#F6F7F9]/90 border-[#DCE5E8]/60"}`}>
      <div className="container-x h-[68px] flex items-center justify-between gap-4">
        <Logo />
        <nav aria-label="Main" className="hidden lg:flex items-center gap-0.5">
          {NAV.map((n) => (
            <NavLink key={n.id} to={n.to} end={n.to === "/"} className={linkCls} data-testid={`nav-${n.id}-link`}>{n.label}</NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <Link to="/software" className="btn-primary hidden sm:inline-flex !py-2.5" data-testid="nav-explore-software-button">
            Explore Software <ArrowRight className="h-4 w-4" />
          </Link>
          <button className="lg:hidden btn-ghost !p-2.5 !rounded-xl border border-[#DCE5E8] bg-white" aria-label={open ? "Close menu" : "Open menu"} aria-expanded={open}
            onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      {open && (
        <nav aria-label="Mobile" data-testid="nav-mobile-menu" className="lg:hidden border-t border-[#DCE5E8] bg-white rise">
          <div className="container-x py-3 flex flex-col">
            {NAV.map((n) => (
              <NavLink key={n.id} to={n.to} end={n.to === "/"} onClick={() => setOpen(false)} className={mobileCls} data-testid={`nav-mobile-${n.id}-link`}>{n.label}</NavLink>
            ))}
            <Link to="/software" onClick={() => setOpen(false)} className="btn-primary mt-3 mb-2" data-testid="nav-mobile-explore-button">Explore Software</Link>
          </div>
        </nav>
      )}
    </header>
  );
}
